export default {"src":"/_next/static/media/switch-pay.1d0df629.svg","height":24,"width":128};